var Handlebars = require("../../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"Styles") : depth0)) != null ? lookupProperty(stack1,"subject") : stack1), depth0))
    + "\">\n    <div class=\"js-content\"></div>\n    <div class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"Styles") : depth0)) != null ? lookupProperty(stack1,"progress") : stack1), depth0))
    + "\">\n        <div class=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"Styles") : depth0)) != null ? lookupProperty(stack1,"score") : stack1), depth0))
    + " "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"scoreColor") : depth0), depth0))
    + "\">\n            <span></span> <label>"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"scoreLabel") : depth0), depth0)) != null ? stack1 : "")
    + "</label>\n        </div>\n        <div>\n            <b>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"tasksMade") : depth0), depth0))
    + "</b> "
    + alias2(__default(require("../../../../../../../../util/handlebarsHelpers/__.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"made",{"name":"__","hash":{},"data":data,"loc":{"start":{"line":8,"column":33},"end":{"line":8,"column":46}}}))
    + "\n        </div>\n    </div>\n</div>\n";
},"useData":true});